import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const ProgressContainer = withStyles({
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
    minHeight: 300,
  },
})(({ classes, className, ...rest }) => (
  <div className={clsx(classes.root, className)} {...rest} />
));

export function CircularContainer(props) {
  const { containerProps, CircularProgressProps } = props;
  return (
    <ProgressContainer {...containerProps}>
      <CircularProgress style={{ margin: 'auto' }} {...CircularProgressProps} />
    </ProgressContainer>
  );
}

CircularContainer.propTypes = {
  containerProps: PropTypes.object,
  CircularProgressProps: PropTypes.object,
};
